import React from 'react';
import {
    Document, Font, Image, Link, Page, StyleSheet, Text, View,
} from '@react-pdf/renderer';
import appleButton from '../assets/images/appStore.png';
import googleButton from '../assets/images/googlePlay.png';
import { getTimezoneDiffName } from '../utils';

const FONT_FAMILY = 'Roboto';
const FONT_FAMILY_BOLD = 'Roboto';
const WIDTH = '40%';

const styles = StyleSheet.create({
    plainText: {
        fontSize: 14,
        fontFamily: FONT_FAMILY,
        lineHeight: 1.5,
        marginRight: 20,
        width: WIDTH,
    },
    emptyText: {
        fontSize: 14,
        lineHeight: 1,
    },
    boldText: {
        fontSize: 14,
        fontFamily: FONT_FAMILY_BOLD,
        fontWeight: 'heavy',
        lineHeight: 1.5,
        width: WIDTH,
        // marginRight: 20,
    },
    marginTop: { marginTop: 20 },
    plainTextMargin: {
        fontSize: 14,
        fontFamily: FONT_FAMILY,
        width: WIDTH,
    },
    boldTextMargin: {
        fontSize: 14,
        fontFamily: FONT_FAMILY,
        width: WIDTH,
        fontWeight: 'heavy',
    },
    headerText: {
        fontFamily: FONT_FAMILY_BOLD,
        fontSize: 22,
        fontWeight: 'heavy',
        marginVertical: 24,
        width: WIDTH,
    },
    deepLink: {
        width: 100,
        height: 100,
    },
    buttons: {
        width: 139,
        height: 40,
        paddingRight: 24,
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: 16,
    },
});

export const Ticket = ({
    logo,
    patient,
    service,
    timeslot,
    doctor,
    specialization,
    clinic,
    cancelLink = '/cancel',
    cancelLinkOld = '/cancel',
    deepLink,
    link,
    linkText,
    allowDeepLink = false,
    bumbaLink = '/bumba',
    mmaLink,
}) => {
    Font.register({
        family: FONT_FAMILY,
        fontWeight: 'normal',
        src:
            'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf',
    });
    Font.register({
        family: FONT_FAMILY,
        fontWeight: 'bold',
        src:
            'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf',
    });

    const tzName = getTimezoneDiffName();

    return (
        <Document language={'russian'}>
            <Page size={'A4'} dpi={110} style={{ padding: 40 }}>
                {!!logo && <><View style={{
                    padding: 0,
                    paddingBottom: 10,
                    paddngTop: 10,
                    justifyContent: 'flex-start',
                    alignContent: 'flex-start',
                    alignItems: 'flex-start',
                }}><Image src={logo} style={{ width: '30%' }}/></View>
                <Text style={[styles.emptyText]}>{' '}</Text></>}
                <View><Text style={[styles.plainText]}>{patient}</Text></View>
                <Text style={[styles.headerText]}>Вы записаны на прием</Text>
                {/* <Text style={[styles.plainText]}>{' '}</Text> */}
                <Text style={[styles.boldTextMargin]}>{timeslot} {tzName ? `(${tzName})` : ''}</Text>
                <Text style={[styles.emptyText]}>{' '}</Text>
                <Text style={[styles.plainText]}>{service}</Text>
                <Text style={[styles.plainText]}>{doctor}</Text>
                <Text style={[styles.plainText]}>{specialization}</Text>
                <Text style={[styles.plainText]}>{clinic}</Text>
                <Text style={[styles.emptyText]}>{' '}</Text>
                {!!mmaLink && <Text style={[styles.boldText]}>{mmaLink?.text ?? ''}</Text>}
                {!!cancelLink.text && !!allowDeepLink &&
                    <Text style={[styles.boldText]}>{cancelLink?.text ?? ''}</Text>}
                {!!bumbaLink.text &&
                    <Text style={[ styles.boldText, styles.marginTop ]}>{bumbaLink?.text ?? ''}</Text>}
                <Text style={[styles.emptyText]}>{' '}</Text>
                <Text style={[styles.plainText]}>Будем рады вас видеть</Text>
                <Text style={[styles.plainText]}>С пожеланиями крепкого здоровья!</Text>
                <Text style={[styles.emptyText]}>{' '}</Text>
                {cancelLinkOld?.text && <>
                    <Text style={[styles.plainText]}>{cancelLinkOld?.text ?? ''}</Text><Text
                        style={[styles.emptyText]}>{' '}</Text></>}
                <Text style={[styles.plainText]}>Для установки приложения перейдите по ссылке или отсканируйте
                    QR-код</Text>
                <Text style={[styles.emptyText]}>{' '}</Text>
                {!!link && !!linkText && <Link style={[styles.plainText]} src={link}>{linkText ?? link}</Link>}
                <Text style={[styles.emptyText]}>{' '}</Text>
                {!!deepLink && <View>
                    <Image src={deepLink ?? ''} style={[styles.deepLink]}>
                    </Image>
                </View>}
                <View style={[styles.buttonContainer]}>
                    <Link src={link}>
                        <Image src={appleButton} style={[styles.buttons]}></Image>
                    </Link>
                    <Link src={link}>
                        <Image src={googleButton} style={[styles.buttons]}></Image>
                    </Link>
                </View>
            </Page>
        </Document>
    );
};
